const adapters = [];
let events = [];
let adaptersInitialized = false;

export const addAdapter = adapter => {
  adapters.push(adapter);
};

export const pushEvent = (action) => {
  if (adaptersInitialized) {
    publishToAdapters(action);
    return;
  }
  events.push(action);
};

export const publishToAdapters = (action) => {
  for (const adapter of adapters) {
    adapter.push(action);
  }
};

export const initAdapters = async () => {
  if (!adapters.length) {
    return;
  }

  try {
    await Promise.all(adapters.map(adapter => adapter.loadScript()));
    adaptersInitialized = true;
    for (const event of events) {
      publishToAdapters(event);
    }
    events = [];
  } catch (e) {
    console.log(e);
  }
}
